

















import Chart from 'vue-apexcharts';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {IDashboardAnalysis} from '@/types/IDashboardTypes';
import {formatNumberWithSpaces} from '@/utils/universalUtils';

@Component({
  name: 'DashboardAnalysisComponent',
  components: {Chart},
})
export default class AnalysisComponent extends Vue {
  @Prop()
  loading!: boolean;

  @Prop()
  data!: {
    data: IDashboardAnalysis[]
    series: number[],
    labels: string[],
    colors: string[]
  };

  series: number | string[] = [];

  chartOptions = {
    tooltip: {
      y: {
        formatter: (seriesValue: number) => formatNumberWithSpaces(seriesValue, 2),
      },
    },
    chart: {
      width: '100%',
      type: 'pie',
      height: '100%'
    },
    labels: [...this.data.labels],
    colors: [...this.data.colors],
    legend: {
      position: 'bottom',
      show: true,
    },
  };
  @Watch('data', {deep: true})
  onLabelsChanged() {
    this.setData();

  }

  setData() {
    this.chartOptions = {
      ...this.chartOptions,
      // @ts-ignore
      labels: [...this.data.labels],
      colors: [...this.data.colors]
    };
    // @ts-ignore
    this.series = this.data.series;
  }
}
